// extracted by mini-css-extract-plugin
module.exports = {"addEventTitle":"EditMilitaryEntity_addEventTitle__3qq9A"};